class BeerStyleSelector extends HTMLElement {
  constructor() {
    super(...arguments);
    this.swatches = null;
  }
  connectedCallback() {
    const container = this.querySelector(".product__linked-products");
    if (!container)
      return;
    this.swatches = this.querySelectorAll(
      ".product__linked-products__swatch a"
    );
    if (this.swatches && this.swatches.length > 0) {
      this.attachEventListeners();
    }
  }
  attachEventListeners() {
    if (!this.swatches)
      return;
    this.swatches.forEach((link) => {
      link.addEventListener("click", this.handleStyleChange.bind(this));
    });
  }
  handleStyleChange(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const href = link.getAttribute("href");
    if (!href || href === "#" || href === "")
      return;
    if (href === window.location.pathname)
      return;
    this.showLoading(link);
    window.location.href = href;
  }
  showLoading(clickedLink) {
    const parentSwatch = clickedLink.closest(
      ".product__linked-products__swatch"
    );
    if (parentSwatch) {
      parentSwatch.classList.add("loading");
    }
  }
}
customElements.define("uwp-beer-style-selector", BeerStyleSelector);
